import { render } from "./PastGoalRate.vue?vue&type=template&id=ab54a482&scoped=true"
import script from "./PastGoalRate.vue?vue&type=script&lang=js"
export * from "./PastGoalRate.vue?vue&type=script&lang=js"

import "./PastGoalRate.vue?vue&type=style&index=0&id=ab54a482&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab54a482"]])

export default __exports__